export default "__VITE_ASSET__Ck0rnIX8__"